import * as React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning' | 'info';
}

export function Badge({ className = '', variant = 'default', children, ...props }: BadgeProps) {
  const variantClass = `shadcn-badge-${variant}`;
  const combined = ['shadcn-badge', variantClass, className].filter(Boolean).join(' ');

  return (
    <div className={combined} {...props}>
      {children}
    </div>
  );
}
